export default __webpack_public_path__ + "static/media/etihadlogo.dd67a657.svg";